import { DataDomain } from './DataDomain';
import { UiDomain } from './UiDomain';
import qs from 'query-string';

/**
 * AppStore
 */
export class AppStore {

    public readonly data = new DataDomain(this);
    public readonly ui = new UiDomain();

    public readonly orgJoinInviteId = qs.parse(location.search, {}).invite as string ?? null;
}